module.exports = __webpack_public_path__ + "img/triangle-light.36a91c21.png";